import { useState, useEffect } from 'react';

export default function useLongPress(callback = () => {}, ms = 0) {
  const [startLongPress, setStartLongPress] = useState(false);

  useEffect(() => {
    let timerId = {} as NodeJS.Timeout
    if (startLongPress) {
      timerId = setTimeout(callback, ms);
    } else if(timerId !== undefined) {
      clearTimeout(timerId);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [callback, ms, startLongPress]);

  return {
    onMouseDown: () => setStartLongPress(true),
    onMouseUp: () => setStartLongPress(false),
    onMouseLeave: () => setStartLongPress(false),
    onTouchStart: () => setStartLongPress(true),
    onTouchEnd: () => setStartLongPress(false),
  }
}